const USERS_KEY = 'nitroUsers';
const USERS_BACKUP_KEY = 'nitroUsersBackup';

/**
 * Safe JSON parse with fallback.
 */
const parseJson = (value, fallback) => {
  if (!value) return fallback;
  try {
    return JSON.parse(value);
  } catch (err) {
    console.warn('[storage] Failed to parse data:', err);
    return fallback;
  }
};

/**
 * Keeps USERS_KEY and USERS_BACKUP_KEY in sync.
 * Always prefers the latest valid structure if desync is detected.
 */
export const ensureUserBackup = () => {
  const storedUsers = localStorage.getItem(USERS_KEY);
  const storedBackup = localStorage.getItem(USERS_BACKUP_KEY);
  // If backup exists but the normal key doesn't, restore from backup
  if (!storedUsers && storedBackup) {
    localStorage.setItem(USERS_KEY, storedBackup);
  }
  // If main exists and (backup is missing or outdated), update the backup
  if (storedUsers && storedUsers !== storedBackup) {
    localStorage.setItem(USERS_BACKUP_KEY, storedUsers);
  }
};

/**
 * Loads all users from storage. Always returns an array.
 */
export const getUsers = () => {
  ensureUserBackup();
  return parseJson(localStorage.getItem(USERS_KEY), []);
};

/**
 * Persists the user array and keeps backup in sync.
 * Supports passing plain arrays or objects.
 */
export const saveUsers = (users) => {
  if (!Array.isArray(users)) {
    console.warn('[storage] saveUsers expected array, got', typeof users);
  }
  const serialized = JSON.stringify(users);
  localStorage.setItem(USERS_KEY, serialized);
  localStorage.setItem(USERS_BACKUP_KEY, serialized);
  return users;
};

/**
 * Update users atomically with a mutator function.
 * The mutator receives a shallow copy of current users.
 * Returns updated user array.
 */
export const updateUsers = (updater) => {
  const currUsers = getUsers();
  let nextUsers;
  try {
    nextUsers = updater(Array.isArray(currUsers) ? [...currUsers] : []);
    if (!Array.isArray(nextUsers)) throw new Error('updateUsers: Updater must return array');
  } catch (e) {
    console.error('[storage] updateUsers error:', e);
    nextUsers = Array.isArray(currUsers) ? [...currUsers] : [];
  }
  return saveUsers(nextUsers);
};

